module.exports = __webpack_public_path__ + "static/media/LogoDark1.d25e25e8.png";